import React, { useMemo } from 'react';
import { useAI } from '@dashboard/context/AIContext';
import PreviewHighlights, { highlightTargets } from './PreviewHighlights';

export default function AIPreviewHighlights({ containerRef, pageType }) {
  const { isOpen, latestChanges, latestPoints, shownChange, focus } = useAI();
  const targets = useMemo(
    () =>
      highlightTargets({
        changes: latestChanges,
        points: latestPoints,
        shown: shownChange,
        pageType,
      }),
    [latestChanges, latestPoints, shownChange, pageType],
  );

  if (!isOpen) return null;

  return <PreviewHighlights containerRef={containerRef} targets={targets} focus={focus} />;
}
